import { type useGuides } from "@knocklabs/react";
import { useEffect } from "react";

/**
 * Custom hook to automatically mark a Knock guide step as seen when the component mounts.
 *
 * @param step - The guide step object returned from Knock's useGuides hook
 *
 * @example
 * ```tsx
 * const { guides } = useGuides(filter);
 * const step = guides[0].getStep();
 * useKnockMarkAsSeen(step);
 * ```
 */
export function useKnockMarkAsSeen(
  step: ReturnType<ReturnType<typeof useGuides>["guides"][number]["getStep"]>
) {
  useEffect(() => {
    if (step) {
      step.markAsSeen();
    }
  }, [step]);
}
